module.exports = __webpack_public_path__ + "img/momo_home_cta_btn.8ce1da88.png";